import { apiFetch, apiSend } from './http';

// POST /api/user/login — authenticate, sets the session cookie on success.
export async function login({ username, password }) {
  const response = await apiSend('/api/user/login', 'POST', { username, password });
  if (!response.ok) throw new Error('Network response was not ok');
}

// POST /api/user/logout — drop the current session.
export async function logout() {
  const response = await apiFetch('/api/user/logout', { method: 'POST' });
  if (!response.ok) throw new Error('Network response was not ok');
}

// POST /api/user/register — request registration (captcha protected).
// Throws Error(result) carrying the server message on failure.
export async function register({ email, captchaId, captchaReply }) {
  const response = await apiSend('/api/user/register', 'POST', {
    email,
    captcha_id: captchaId,
    captcha_reply: captchaReply,
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data?.result);
  return data;
}

// POST /api/user/reset_request — lost password recovery, phase 1 (captcha protected).
export async function resetRequest({ email, captchaId, captchaReply }) {
  const response = await apiSend('/api/user/reset_request', 'POST', {
    email,
    captcha_id: captchaId,
    captcha_reply: captchaReply,
  });
  if (!response.ok) throw new Error('Network response was not ok');
}

// POST /api/user/reset_passwd — lost password recovery, phase 2.
export async function resetPassword({ email, token, password }) {
  const response = await apiSend('/api/user/reset_passwd', 'POST', { email, token, password });
  if (!response.ok) throw new Error('Network response was not ok');
}

// POST /api/user/passwd — change the current user's password.
export async function changePassword({ password, newPassword }) {
  const response = await apiSend('/api/user/passwd', 'POST', {
    password,
    new_password: newPassword,
  });
  if (!response.ok) throw new Error('Network response was not ok');
}
